import React from "react";
import RightLoan from "../../PicesForPages/WhichLoanisRightForYou.jpg";
import FreeConsultation from "../Form/FreeConsultation";

function RightLoanForYou() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={RightLoan}
          alt="RightLoanImage"
          className="background-video RightLoanImage"
        />
        <div className="purchasetopBox">
          <span>Which Loan is Right For You?</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftContent">
              In the past, most homeowners were offered a standard 30-year fixed
              mortgage. Today, with a wide range of loan programs available,
              selecting the right option can potentially save you hundreds of
              dollars on your monthly payments.
            </span>

            {/* Table 1 */}
            <table className="loanTable">
              <thead>
                <tr>
                  <th className="loanTable_left">
                    How Long Do You Intend to Stay in Your Home?
                  </th>
                  <th className="loanTable_right">Our Recommendation:</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="loanTable_left">
                    Short-Term Stay (1–3 Years)
                  </td>
                  <td className="loanTable_right">
                    3/1 ARM, 1-Year ARM, or 6-Month ARM
                  </td>
                </tr>
                <tr className="loanTable_td_bgcolor">
                  <td className="loanTable_left">
                    Moderate Duration (3–5 Years)
                  </td>
                  <td className="loanTable_right">5/1 ARM</td>
                </tr>
                <tr>
                  <td className="loanTable_left">
                    Mid-Term Commitment (5–7 Years)
                  </td>
                  <td className="loanTable_right">7/1 ARM</td>
                </tr>
                <tr className="loanTable_td_bgcolor">
                  <td className="loanTable_left">
                    Long-Term Outlook (7–10 Years)
                  </td>
                  <td className="loanTable_right">
                    10/1 ARM, 30-Year Fixed, or 15-Year Fixed
                  </td>
                </tr>
                <tr>
                  <td className="loanTable_left">
                    Extended Ownership (10+ Years)
                  </td>
                  <td className="loanTable_right">
                    30-Year Fixed or 15-Year Fixed
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Table 2 */}
            <table className="loanTable loanTable00">
              <thead>
                <tr>
                  <th>Loan Programs</th>
                  <th>Advantages</th>
                  <th>Disadvantages</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="loanTable_left">
                    <b>
                      30 year Fixed <br /> 15 year Fixed
                    </b>
                  </td>
                  <td>
                    <ul>
                      <li>
                        Monthly payments remain consistent and predictable
                      </li>
                      <li>
                        Interest rate remains locked for the life of the loan
                      </li>
                      <li>Provides protection against rising interest rates</li>
                      <li>Opportunity to refinance if rates decrease</li>
                    </ul>
                  </td>
                  <td className="loanTable_right">
                    <ul>
                      <li>Typically comes with a higher interest rate</li>
                      <li>May result in higher monthly mortgage payments</li>
                      <li>
                        Rate will not automatically decrease if market rates
                        improve
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
              <tfoot className="loanTable_tfoot">
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      textAlign: "center",
                      border: "none",
                      paddingTop: "20px",
                    }}
                  >
                    <a
                      href="https://vidhimortgage.my1003app.com/"
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        color: "#005bb5",
                        textDecoration: "none",
                      }}
                    >
                      Get Started Today!
                    </a>
                  </td>
                </tr>
              </tfoot>
            </table>

            {/* Table 3 */}
            <table className="loanTable loanTable00">
              <thead>
                <tr>
                  <th>Loan Programs</th>
                  <th>Advantages</th>
                  <th>Disadvantages</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="loanTable_left">
                    <b>Adjustable Rate Mortgages (ARMs)</b>
                  </td>
                  <td>
                    <ul>
                      <li>Stable and predictable monthly payments</li>
                      <li>Locked-in interest rate for peace of mind</li>
                      <li>Safeguarded against rising market rates</li>
                      <li>Opportunity to refinance if rates decrease</li>
                    </ul>
                  </td>
                  <td className="loanTable_right">
                    <ul>
                      <li>Typically comes with a higher interest rate</li>
                      <li>May result in increased monthly payments</li>
                      <li>No automatic benefit if market rates decline</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
              <tfoot className="loanTable_tfoot">
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      textAlign: "center",
                      border: "none",
                      paddingTop: "20px",
                    }}
                  >
                    <a
                      href="https://vidhimortgage.my1003app.com/"
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        color: "#005bb5",
                        textDecoration: "none",
                      }}
                    >
                      Get Started Today!
                    </a>
                  </td>
                </tr>
              </tfoot>
            </table>

            {/* Table 4 */}
            <table className="loanTable loanTable00">
              <thead>
                <tr>
                  <th>Loan Programs</th>
                  <th>Advantages</th>
                  <th>Disadvantages</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="loanTable_left">
                    <b>Balloon Mortgages</b>
                  </td>
                  <td>
                    <ul>
                      <li>Enjoy lower initial monthly payments</li>
                      <li>Reduced payments during the shorter loan term</li>
                      <li>
                        Many balloon mortgage options allow you to transition
                        into a new loan after the initial term.
                      </li>
                    </ul>
                  </td>
                  <td className="loanTable_right">
                    <ul>
                      <li>
                        Potential for higher interest rates after the initial
                        fixed period ends
                      </li>
                      <li>
                        Possibility of foreclosure if the balloon payment cannot
                        be met, refinancing is not secured, or the conversion
                        option is not exercised
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
              <tfoot className="loanTable_tfoot">
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      textAlign: "center",
                      border: "none",
                      paddingTop: "20px",
                    }}
                  >
                    <a
                      href="https://vidhimortgage.my1003app.com/"
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        color: "#005bb5",
                        textDecoration: "none",
                      }}
                    >
                      Get Started Today!
                    </a>
                  </td>
                </tr>
              </tfoot>
            </table>

            {/* Table 5 */}
            <table className="loanTable loanTable00">
              <thead>
                <tr>
                  <th>Loan Programs</th>
                  <th>Advantages</th>
                  <th>Disadvantages</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="loanTable_left">
                    <b>First-Time Homebuyer Programs</b>
                  </td>
                  <td>
                    <ul>
                      <li>Lower upfront down payment requirements</li>
                      <li>Simplified qualification process</li>
                      <li>
                        Potential access to more competitive interest rates
                      </li>
                    </ul>
                  </td>
                  <td className="loanTable_right">
                    <ul>
                      <li>
                        May include income caps and property value restrictions
                      </li>
                      <li>
                        Certain government-assisted programs may require
                        repayment (recapture tax) if the property is sold within
                        a specified timeframe
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
              <tfoot className="loanTable_tfoot">
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      textAlign: "center",
                      border: "none",
                      paddingTop: "20px",
                    }}
                  >
                    <a
                      href="https://vidhimortgage.my1003app.com/"
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        color: "#005bb5",
                        textDecoration: "none",
                      }}
                    >
                      Get Started Today!
                    </a>
                  </td>
                </tr>
              </tfoot>
            </table>

            {/* Table 6 */}
            <table className="loanTable loanTable00">
              <thead>
                <tr>
                  <th>Loan Programs</th>
                  <th>Benefits</th>
                  <th>Considerations</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="loanTable_left">
                    <b>No Point, No Fee Programs</b>
                  </td>
                  <td>
                    <ul>
                      <li>Zero out-of-pocket closing costs</li>
                      <li>Reduced cash needed at closing</li>
                    </ul>
                  </td>
                  <td className="loanTable_right">
                    <ul>
                      <li>Slightly higher interest rates</li>
                      <li>Increased monthly payments</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
              <tfoot className="loanTable_tfoot">
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      textAlign: "center",
                      border: "none",
                      paddingTop: "20px",
                    }}
                  >
                    <a
                      href="https://vidhimortgage.my1003app.com/"
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        color: "#005bb5",
                        textDecoration: "none",
                      }}
                    >
                      Get Started Today!
                    </a>
                  </td>
                </tr>
              </tfoot>
            </table>

            {/* Table 7 */}
            <table className="loanTable loanTable00">
              <thead>
                <tr>
                  <th>Loan Programs</th>
                  <th>Key Benefits</th>
                  <th>Considerations</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="loanTable_left">
                    <b>Home Equity Line of Credit</b>
                  </td>
                  <td>
                    <ul>
                      <li>Access funds only as needed</li>
                      <li>Interest is charged solely on the amount utilized</li>
                      <li>Enjoy convenient and flexible fund accessibility</li>
                      <li>Interest payments may offer tax advantages</li>
                    </ul>
                  </td>
                  <td className="loanTable_right">
                    <ul>
                      <li>
                        Interest rates may fluctuate and can reach higher limits
                      </li>
                      <li>Monthly payment amounts may vary over time</li>
                      <li>
                        Refinancing your primary mortgage may be more complex
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
              <tfoot className="loanTable_tfoot">
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      textAlign: "center",
                      border: "none",
                      paddingTop: "20px",
                    }}
                  >
                    <a
                      href="https://vidhimortgage.my1003app.com/"
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        color: "#005bb5",
                        textDecoration: "none",
                      }}
                    >
                      Get Started Today!
                    </a>
                  </td>
                </tr>
              </tfoot>
            </table>

            {/* Table 8 */}
            <table className="loanTable loanTable00">
              <thead>
                <tr>
                  <th>Loan Programs</th>
                  <th>Advantages</th>
                  <th>Disadvantages</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="loanTable_left">
                    <b>Home Equity Fixed Loan</b>
                  </td>
                  <td>
                    <ul>
                      <li>Consistent and predictable monthly payments</li>
                      <li>
                        Interest payments may offer potential tax benefits
                      </li>
                    </ul>
                  </td>
                  <td className="loanTable_right">
                    <ul>
                      <li>
                        Typically carries higher rates compared to primary
                        mortgages
                      </li>
                      <li>
                        May limit flexibility when refinancing your first
                        mortgage
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
              <tfoot className="loanTable_tfoot">
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      textAlign: "center",
                      border: "none",
                      paddingTop: "20px",
                    }}
                  >
                    <a
                      href="https://vidhimortgage.my1003app.com/"
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        color: "#005bb5",
                        textDecoration: "none",
                      }}
                    >
                      Get Started Today!
                    </a>
                  </td>
                </tr>
              </tfoot>
            </table>

            <span className="purchaseBottomLeftContent">
              Along with these standard loan programs, we provide a wide range
              of specialized loan options tailored to meet your unique
              needs—please call or email us for more information.
            </span>

            <div className="purchaseBottomLeftButton">
              <a
                href="https://vidhimortgage.my1003app.com/"
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now
              </a>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default RightLoanForYou;
